module.exports = __webpack_public_path__ + "img/CalendarMonthOutlined.ae55a61a.svg";